import React from "react";
import { Box, Typography, Link, Grid } from "@mui/material";
import wflogo from '../../media/wflogoblack.png';
import alignlogo from '../../media/A-LIGN-SOC.png';

const Footer = () => {

  return (
    <Box
      sx={{
        backgroundColor: "rgb(236, 239, 241)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 1,
        color: "black",
      }}
      width="100%"
    >
      <Grid container justifyContent="center" spacing={2} alignItems="center">
        <Grid item>
          <img
            src={alignlogo}
            alt="A-LIGN-SOC"
            style={{ height: "57px", marginTop: "3px" }}
          />
        </Grid>
        <Grid item>
          <Box textAlign="center">
            <img style={{ height: "28px" }} src={wflogo} alt="WF Logo" />
            <Typography variant="body2" sx={{ color: "black" }}>
              Delivered by IPCS &reg;
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Typography variant="body2" sx={{ color: "black" }} align="center">
            This software is licensed to the user. Use of the software
            constitutes acceptance of the terms and conditions of the License
            Agreement.
            <br />
            &copy; IPCS®. &copy; WorkFinity®.
            <br />
            All rights reserved. Under US Patent Protection.
          </Typography>
        </Grid>
        <Grid item style={{ padding: "0px", marginBottom: "21px", marginLeft: "20px" }}>
          <Typography variant="body1" fontWeight="bold">
            Customer Support:{" "}
            <Link href="mailto:Support1@workfinity.com" fontWeight="bold" sx={{ textDecoration:"none" }}>
              Support1@workfinity.com
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
